/* eslint-disable max-len */
(() => {
  const modalOverlay = document.querySelector('.js-modal-overlay');
  if (!modalOverlay) {
    return;
  }
  const modalOpenElements = document.querySelectorAll('.js-modal-open');
  const modalContentElement = modalOverlay.querySelector('.js-modal-content');
  window.mds = window.mds || {};
  async function fetchUrl(url) {
    const init = {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
    const resp = await fetch(url, init);
    if (!resp.ok) {
      throw new Error(`HTTP error! Status: ${resp.status}`);
    }

    const text = await resp.text();
    return text;
  }

  function clearModal() {
    while (modalContentElement.firstChild) {
      modalContentElement.removeChild(modalContentElement.firstChild);
    }
  }

  let modalType = 'static';
  if (modalOpenElements && modalOverlay) {
    modalOpenElements.forEach((modalOpenElement) => {
      modalType = modalOpenElement.getAttribute('data-type');
      modalOpenElement.addEventListener('click', async (ev) => {
        ev.preventDefault();
        let href = false;
        if (modalType === 'dynamic') {
          href = ev.currentTarget.getAttribute('data-href');
        }
        if (href) {
          const data = await fetchUrl(href);
          modalContentElement.appendChild(
            document.createRange().createContextualFragment(data),
          );
          modalOverlay.dispatchEvent(new CustomEvent('modal-opened', { detail: { formTarget: href } }));
        }
        document.body.style.overflow = 'hidden';
        modalOverlay.classList.add('modal-is-open');
      });
    });
    const modalCloseElements = modalOverlay.querySelectorAll('.js-modal-close');
    modalCloseElements.forEach((modalCloseElement) => {
      modalCloseElement.addEventListener('click', () => {
        modalOverlay.classList.remove('modal-is-open');
        document.body.style.overflow = '';
        if (modalType === 'dynamic') {
          clearModal();
        }
      });
    });

    modalOverlay.addEventListener('modal-opened', (event) => {
      const formName = modalOverlay.getAttribute('data-form');
      let modalForm = modalOverlay.querySelector(`[name = ${formName}]`);
      if (modalForm) {
        const { formTarget } = event.detail;
        window.mds.modalFormSubmit = async () => {
          if (formTarget) {
            const data = await fetch(formTarget, {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: new FormData(modalOverlay.querySelector('[name = "contact"]')),
            });
            const text = await data.text();
            window.grecaptcha.reset();
            clearModal();
            modalForm = null;
            modalContentElement.appendChild(
              document.createRange().createContextualFragment(text),
            );
          }
        };
      }
    });
  }
})();
